import {
    getField,
    updateField
} from "vuex-map-fields"
import {
    ADD_ROW, RESET_FORM
} from "../../constant-types"
import { defaultRemoveRowMutation, defaultSetFormMutation, defaultSetFormsMutation } from "../../default-method"

const getDefaultState = () => {
    return {
        rows: [getDefaultRowState()]
    }
}

const getDefaultRowState = () => ({
    id: '',
    name: '',
})

export default ({
    namespaced: true, 
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [ADD_ROW](state) {
            state.rows.push(getDefaultRowState())
        },
        ...defaultRemoveRowMutation,
        [RESET_FORM](state) {
            Object.assign(state, getDefaultState())
        },
        ...defaultSetFormMutation,
        ...defaultSetFormsMutation,
        updateField

    },
    // can async
    actions: {

    },
    // call variable with custom display
    getters: {
        getField
    }
})